import styled from 'styled-components';
import { Colors } from 'basic-ui-lib/constants';
import { Text } from 'basic-ui-lib/components/Text';
import { IcChevronDown } from 'basic-ui-lib/icons';
import { LayoutCode } from 'modules/channel/services/constants';
import { ChangeLayoutModal, useChangeLayoutModalRef } from '../ChangeLayoutModal';
import { LAYOUT_CONFIGS } from '../ChangeLayoutModal/ChangeLayoutModal';
import { Col } from 'basic-ui-lib';

interface LayoutSelectorProps {
  value: LayoutCode;
  onChange: (layout: LayoutCode) => void;
}

const LayoutSelector = ({ value, onChange }: LayoutSelectorProps) => {
  const modalRef = useChangeLayoutModalRef();

  const handleOpenModal = () => {
    modalRef.current?.show(value, onChange);
  };

  const layoutName = LAYOUT_CONFIGS.find((layout) => layout.layoutCode === value)?.name;
  return (
    <>
      <SelectorButton onClick={handleOpenModal} type='button'>
        <Col gap={0}>
          <LabelText>Lay Out</LabelText>
          <TextWrapper>
            <Text body_1 medium color="neutral.text.5" left>
              {layoutName || 'Select Layout'}
            </Text>
          </TextWrapper>
        </Col>
        <IcChevronDown fill={Colors.primary[5]} width={16} height={16} />
      </SelectorButton>

      <ChangeLayoutModal ref={modalRef} />
    </>
  );
};

export default LayoutSelector;

const SelectorButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  height: 49px;
  width: 100%;
  background: ${Colors.neutral.bg[1]};
  border: 1px solid ${Colors.neutral.border[1]};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;

  &:hover {
    border-color: ${Colors.primary[5]};
  }

  &:focus {
    border-color: ${Colors.primary[5]};
    outline: none;
  }
`;

const TextWrapper = styled.div`
  flex: 1;
  min-width: 0;
  text-align: left;
  
  .custom-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const LabelText = styled.span`
  font-family: 'Poppins';
  font-size: 11px;
  font-weight: 400;
  color: ${Colors.neutral.text[4]};
  z-index: 1;
  pointer-events: none;
  text-align: left;
`;
